/* eslint-disable @web-monorepo/no-css-file-imports */
import "extended-proptypes/lib/extend-from-standalone";
import "react-flexbox-layout/lib/styles.css";
import "src/stylesheets/normalize.css";
import "src/stylesheets/transitions.css";
import "src/stylesheets/base.css";

import { useParams } from "react-router-dom";
import ConundrumsList from "src/pods/conundrums/components/List";
type ConundrumsListPageParams = {
  mountPoint: string;
  classId: string;
};

export default function ConundrumsListPage() {
  const params = useParams<ConundrumsListPageParams>();
  return <ConundrumsList params={params} />;
}
